<template>
	<el-time-picker v-if="model"
					is-range
					v-model="model[data.fieldId]"
					:range-separator="data.setting.rangeSeparator"
					:start-placeholder="data.setting.startPlaceholder"
					:end-placeholder="data.setting.endPlaceholder"
					:picker-options="{
						selectableRange: data.setting.selectableRange,
						format: data.setting.format
					}"
					:value-format="data.setting.valueFormat"
					:prefix-icon="data.setting.prefixIcon"
					:placeholder="data.placeholder"
					:disabled="disabled"
					@change="timeRangeChange"
					style="width: 100%">
	</el-time-picker>
	<el-time-picker v-else
					is-range
					v-model="data.value"
					:range-separator="data.setting.rangeSeparator"
					:start-placeholder="data.setting.startPlaceholder"
					:end-placeholder="data.setting.endPlaceholder"
					:picker-options="{
						selectableRange: data.setting.selectableRange,
						format: data.setting.format
					}"
					:value-format="data.setting.valueFormat"
					:prefix-icon="data.setting.prefixIcon"
					:placeholder="data.placeholder"
					:disabled="disabled"
					@change="timeRangeChange"
					style="width: 100%">
	</el-time-picker>
</template>

<script>
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpTimePickerMultiple',
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	inject: [ 'customFormOptions' ],
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		}
	},
	methods: {
		focus() {
			if (Array.isArray(this.data.value) && this.data.value.length === 0)
				this.data.value = [new Date(), new Date()]
		},

		timeRangeChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>